module.exports = {
  ...require("./selection.js"),
  ...require("./costumes.js"),
  ...require("./sounds.js"),
  ...require("./linkdialog.js"),
};
